import { FC } from 'react';

export const SecuredByStripe: FC = () => (
  <div className="secured-by-stripe">
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="10" viewBox="0 0 9 10" fill="none">
      <path
        d="M2.89286 2.8125V3.75H6.10714V2.8125C6.10714 1.94922 5.38795 1.25 4.5 1.25C3.61205 1.25 2.89286 1.94922 2.89286 2.8125ZM1.60714 3.75V2.8125C1.60714 1.25977 2.9029 0 4.5 0C6.0971 0 7.39286 1.25977 7.39286 2.8125V3.75H7.71429C8.42344 3.75 9 4.31055 9 5V8.75C9 9.43945 8.42344 10 7.71429 10H1.28571C0.576563 10 0 9.43945 0 8.75V5C0 4.31055 0.576563 3.75 1.28571 3.75H1.60714Z"
        fill="#828282"
      />
    </svg>
    Secured by Stripe
  </div>
);
